import { Testimonial } from '../components/carousel/testimonialsCarousel'
export const testimonialsDataMock: Testimonial[] = [
  {
    id: 1,
    name: 'Derek Lewis - Brigham Young University - Idaho',
    content:
      'OnTheHub is an amazing site that makes it possible to get software for school at much cheaper prices and lets you keep them after school is done. It has personally helped me out a lot with getting Microsoft and other things for free in some cases.',
  },
  {
    id: 2,
    name: 'Angelia Jones - OnTheHub Customer',
    content: 'Great discounts for students!',
  },
  {
    id: 3,
    name: 'Michael - OnTheHub Customer',
    content: 'OnTheHub is great and gets 5 star.',
  },
]
